/* eslint-disable camelcase */
import {
  TextSettings,
  CheckboxSettings,
  RadioSettings,
  RichTextSettings,
  NumberSettings
} from '../../../vue_shared/types/request_fields'

export enum RequestFieldType {
  Text = 'text',
  Checkbox = 'checkbox',
  Radio = 'radio',
  RichText = 'rich_text',
  Number = 'number'
}

export type TextFieldValue = string | null
export type NumberFieldValue = number | null
export type RichTextFieldValue = string | null
export type CheckboxFieldValue = Array<{ name: string; uuid: string }>
export type RadioFieldValue = Array<{ name: string; uuid: string }>
interface FieldValueMap {
  [RequestFieldType.Text]: TextFieldValue
  [RequestFieldType.Checkbox]: CheckboxFieldValue
  [RequestFieldType.Radio]: RadioFieldValue
  [RequestFieldType.RichText]: RichTextFieldValue
  [RequestFieldType.Number]: NumberFieldValue
}

interface FieldSettingsMap {
  [RequestFieldType.Text]: TextSettings
  [RequestFieldType.Checkbox]: CheckboxSettings
  [RequestFieldType.Radio]: RadioSettings
  [RequestFieldType.RichText]: RichTextSettings
  [RequestFieldType.Number]: NumberSettings
}

type RequestFieldTypedValue = {
  [K in RequestFieldType]: {
    field_type: K
    value: FieldValueMap[K]
    type_settings: FieldSettingsMap[K]
  }
}[RequestFieldType]

export enum EditingAccess {
  ADMIN = 0,
  PUBLISHER = 1,
  REQUESTER = 2
}
type RequestFieldVersion = {
  editing_access: EditingAccess
  visibility: number
  id: number
}

export type RequestFieldValue = {
  id: number
  field_settings_have_changed: boolean
  display_name: string
  field_value_was_edited: boolean
  request_field_version: RequestFieldVersion
} & RequestFieldTypedValue

interface Poc {
  id: number
  email_or_name: string
  has_tasks: boolean
  name_with_email: string
  undeliverable_email: boolean
}

export interface Request {
  anticipated_fulfilled_at: string
  custom_fields: object | null
  department_names: string
  departments: Array<any>
  exempt_from_retention: boolean
  is_current_requester: boolean
  poc: Poc
  pretty_id: string
  request_date: string
  request_due_date: string
  request_staff_cost: string
  request_staff_hours: string
  request_state: string
  request_text: string
  request_visibility: string
  request_submit_type: string
  requester: object
  visibility: string
  request_field_values: Array<RequestFieldValue>
}
